import React, { useEffect, useState } from 'react';
import { Switch } from 'antd';
import { CircularProgress } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import NoxTable from '../../component/Table';
import InnerHeader from '../../component/InnerHeader';
import { fetchLanguages, updateLanguage } from '../../actions/LanguagesAction';

const useStyles = makeStyles({
  primary: {
    color: '#5564F8'
  },
  secondary: {
    color: '#000000'
  }
});

const Language = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dispatch = useDispatch();
  const classes = useStyles();
  const columns = [
    {
      dataIndex: 'local',
      key: 'local',
      render: (local) => {
        return (
          <div
            style={{
              color: 'black',
              fontWeight: 700,
              // width: "256px",
              textAlign: 'start'
            }}
          >
            {local}
          </div>
        );
      },
      sorter: (a, b) => a.local.localeCompare(b.local),
      title: 'Local'
    },
    {
      dataIndex: 'completion',
      key: 'completion',
      render: (value, enable) => (
        <div
          style={{
            display: 'flex',
            margin: 'auto',
            position: 'relative'
          }}
        >
          <CircularProgress
            classes={{
              colorPrimary: classes.primary,
              colorSecondary: classes.secondary
            }}
            color={enable.enable ? 'primary' : 'secondary'}
            size={44}
            thickness={4.5}
            value={value}
            variant="determinate"
          />
          <h1
            style={{
              fontSize: '12px',
              left: '22px',
              position: 'absolute',
              top: '22px',
              transform: 'translate(-50%, -50%)'
            }}
          >
            {value}%
          </h1>
        </div>
      ),
      sorter: (a, b) => a.completion.localeCompare(b.completion),
      title: 'Completion'
    },
    {
      dataIndex: 'fallback',
      key: 'fallback',
      render: (fallback) => {
        return <div style={{ textAlign: 'start' }}>{fallback}</div>;
      },
      sorter: (a, b) => a.fallback.localeCompare(b.fallback),
      title: 'Fallback'
    },
    {
      dataIndex: 'enable',
      key: 'enable',
      render: (enable, language) => {
        return (
          <Switch
            defaultChecked={enable}
            onChange={(enable) => handleEnableChange(enable, language)}
            style={{ display: 'flex' }}
          />
        );
      },
      sorter: (a, b) => a.enabled - b.enabled,
      title: 'Enabled'
    }
  ];

  const mapToTable = (languagesWithCompletion) => {
    const data = [];

    if (!languagesWithCompletion || languagesWithCompletion.length === 0) {
      return data;
    }

    languagesWithCompletion.forEach(({ _id, name, enable, key, completion }) => {
      data.push({
        _id,
        completion,
        enable,
        fallback: 'English',
        key,
        local: name
      });
    });

    return data;
  };

  useEffect(() => {
    async function load() {
      dispatch(fetchLanguages());
    }

    load();
  }, [dispatch]);

  const languagesWithCompletion = useSelector(({ language }) => language.languagesWithCompletion);

  const handleEnableChange = (enable, language) => {
    dispatch(updateLanguage(enable, language._id));
  };

  const data = mapToTable(languagesWithCompletion);

  return (
    <div>
      <InnerHeader subtitle={data.length} title="Languages" />
      <NoxTable
        actions={[]}
        checkbox
        columns={columns}
        data={data}
        searchBy="local"
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        title="Language"
      />
    </div>
  );
};

export default Language;
